export default "__VITE_ASSET__CwxJ2R6x__"